class SectionPackages extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Add data attribute to identify this as a packages section
    this.setAttribute('data-packages', '');
  }

  disconnectedCallback() {
    // Clean up if needed
  }
}

customElements.define('section-packages', SectionPackages);
